// src/components/Quiz.jsx
import React, { useState } from "react";

function Quiz({ questions }) {
  const [selected, setSelected] = useState({});
  const [result, setResult] = useState(null);

  const handleSelect = (questionIdx, score) => {
    setSelected((prev) => ({
      ...prev,
      [questionIdx]: score,
    }))
  };

  const handleSubmit = () => {
    // Tally scores to find most frequently chosen
    const freq = {};

    Object.keys(selected).forEach((key) => {
      freq[selected[key]] = (freq[selected[key]] || 0) + 1;
    });

    const maxScore = Object.keys(freq).reduce((a, b) =>
      freq[a] > freq[b] ? a : b
    );

    setResult(maxScore);
  };

  const resultMessage = (res) => {
    if (res === "home") {
      return "🏡 Your main goal is to buy a home. We'll send you tailored guides about mortgage, saving, and first-time buyer programs.";
    } else if (res === "credit") {
      return "💳 Your main focus is improving your credit score. We'll send you tips to boost it quickly.";
    } else if (res === "business") {
      return "🚀 You want to start a small business. We'll show you resources about financing, paperwork, and developing your business.";
    } else if (res === "remittances") {
      return "🌍 Your priority is sending money back home safely. We'll guide you through low-cost transfer options.";
    } else {
      return "🎉 We'll customize financial tips based on your answers.";
    }
  };
  
  return (
    <div style={{ padding: "20px", color: "#245580" }}>
      <h1>Discover Your Financial Goals</h1>
      {questions?.map((q, idx) => (
        <div key={idx} style={{ marginBottom: "15px", padding: "10px", background: "#edf5ff", borderRadius: "6px" }}>
          <p>{q.question}</p>
          {q.options?.map((opt, i) => (
            <label key={i} style={{ display: "block", marginBottom: "5px", cursor: "pointer" }}>
              <input
                type="radio"
                name={`question-${idx}`}
                onChange={() => handleSelect(idx, opt.score)}
                checked={selected[idx] === opt.score}
              />
              {opt.answer}
            </label>
          ))}
        </div>
      ))}
      <button onClick={handleSubmit} style={{ marginTop: "20px", padding: "10px 20px", background: "#245580", color: "#ffffff", border: "none", borderRadius: "6px", cursor: "pointer" }}>Submit</button>

      {result && (
        <div style={{ marginTop: "20px" }}>
          <h2>{resultMessage(result)}</h2>
          <p>Enter your email below to start our Free Course tailored to you (in Portuguese)!</p>
          <input
            type="email"
            placeholder="Enter your email"
            style={{ padding: "10px", marginBottom: "10px" }}
          />
          <br />
          <button style={{ padding: "10px 20px", background: "#245580", color: "#ffffff", border: "none", borderRadius: "6px" }}>Subscribe</button>
        </div>
      )}

    </div>
  )
}

export default Quiz;
